import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initA11y, installKeyboardRestore, installViewportVars } from '@ofc/ui';
import { App } from './App';
import { Recover, reloadOnce } from './components/Recover';

// Applied before the first paint so the chosen palette does not flash.
initA11y();
// Once, for every screen: tells the CSS how much of the screen the keyboard leaves,
// and undoes the scroll iOS leaves behind on pages that are not game screens.
installViewportVars();
installKeyboardRestore();

// Each game is its own file, named after its contents. A phone that opened the
// page before a deploy asks for the old names, which are gone: reload once to
// pick up the new page. See Recover for the rest of the story.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnce()) event.preventDefault();
});
// A page that has been up a while may reload for the next deploy too.
window.setTimeout(() => {
  try {
    sessionStorage.removeItem('ofc:reloaded-for-update');
  } catch {
    // Storage blocked: nothing to clear.
  }
}, 30_000);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Recover>
      <App />
    </Recover>
  </StrictMode>,
);

// Keeps the title index, the games' data and the app's own files on the phone, so
// a second visit is quick. Failure is harmless: everything comes over the network.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
